// removed by extract-text-webpack-plugin
module.exports = {"breakdown-row":"breakdown-row_breakdown-row--2MafWCQJ","breakdownRow":"breakdown-row_breakdown-row--2MafWCQJ","breakdown-row__title":"breakdown-row_breakdown-row__title--_gOFE4zf","breakdownRowTitle":"breakdown-row_breakdown-row__title--_gOFE4zf","breakdown-row__progress-bar":"breakdown-row_breakdown-row__progress-bar--1omqSt8K","breakdownRowProgressBar":"breakdown-row_breakdown-row__progress-bar--1omqSt8K","breakdown-row__value":"breakdown-row_breakdown-row__value--TiWpqsH-","breakdownRowValue":"breakdown-row_breakdown-row__value--TiWpqsH-"};


//////////////////
// WEBPACK FOOTER
// ./components/breakdown-row/src/styles/breakdown-row.scss
// module id = 2343
// module chunks = 0